<script>
import SimSelectRadio from "./SimSelectRadio.vue";
export default {
  components: {
    SimSelectRadio,
  },
  props: {
    plan: {
      type: Object,
      required: true,
    },
    identifier: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
    },
    mobile_form: {
      type: Object,
    },
    details: {
      type: Object,
    },
  },

  data() {
    return {
      uniqueId: "",
      errorMessages: [],
      errors_text: {
        user_sim_type: "Please select sim type",
        ["user_sim_type_" + this.identifier]: "Please select sim type",
        user_mobile_brand: "Please Select Phone Brand",
        user_mobile_model: "Please Select Phone Model",
      },
      errors: false,
      error_content: {
        user_sim_type: "Please select sim type",
        ["user_sim_type_" + this.identifier]: "Please select sim type",
        user_mobile_brand: "Please Select Phone Brand",
        user_mobile_model: "Please Select Phone Model",
      },
      errors_object: {
        simtype: false,
      },
      user_sim_type: null,
      mobile_form: {
        ["user_sim_type_" + this.identifier]: null,
      },
      selected_plan: null,
      data: null,
      minutes: null,
      sms: null,
      amount: null,
      selected_type: null,
      sim_name: null,
      months: null,
      planname: null,
      datatext: null,
      normalprice: null,
      offersubscription: null,
    };
  },

  computed: {
    three_month_total() {
      const amount = parseFloat(this.plan.amount);
      return amount * 3;
    },
    userData() {
      const dynamicPropertyName = "user_sim_type_" + this.identifier;
      return {
        [dynamicPropertyName]: null,
      };
    },
  },
  watch: {
    uniqueId(newVal) {
      // Update userData when uniqueId changes
      this.userData = {
        ...this.userData,
        ["user_sim_type_" + newVal]: null,
      };
    },
  },
  methods: {
    returnIndex() {
      this.$emit("indexPassUp", this.index);
    },
    passMoreInfo() {
      this.errors = false;
      this.errorMessages = [];
      const dynamicPropertyName1 = "user_sim_type_" + this.identifier;
      const simPropertyValue = this.mobile_form[dynamicPropertyName1];

      this.selected_type = "physical"; // comment out these next 2 lines and uncomment below to add
      this.sim_name = "Physical Sim"; // sim type selecting again (remember to uncomment the hidden html parts too)

      // if (simPropertyValue===null) {
      //   this.errors_object.user_sim_type= true;
      //   this.errors = true;
      //   this.errorMessages.push(this.error_content.user_sim_type);
      // }

      // if( this.errors==true){
      //     return;
      // }

      // this.selected_type=simPropertyValue;

      // if(simPropertyValue=="esim"){
      //   //  this.sim_name="eSim (Digital)";
      //   this.errors_object.user_sim_type= true;
      //   this.errors = true;
      //   this.errorMessages.push('eSim Coming Soon');
      //   return;
      // }else{
      //   this.sim_name="Physical Sim";
      // }

      this.selectedPlan();
    },
    selectedPlan() {
      const path = window.location.pathname;

      this.selected_plan = this.plan.id;
      this.data = this.plan.data;
      this.minutes = this.plan.minute;
      this.sms = this.plan.sms;
      this.amount = this.plan.amount_offer;
      this.months = this.plan.months;
      this.datatext = this.plan.text;
      this.normalprice = this.plan.amount_regular;
      this.offersubscription = this.plan.amount_offer_first_subscription;
      this.offerstatus = this.plan.offer_status;
      this.originalamount = this.plan.amount;

      this.planname = this.plan.name; //this.months + ' months, ' + this.data + ", "+ this.sim_name ;

      localStorage.removeItem(
        "selectedPlan",
        "gB",
        "minutes",
        "sms",
        "amount",
        "selectedtype",
        "months",
        "sim_name",
        "planname",
        "datatext",
        "offersubscription",
        "offerstatus",
        "originalamount"
      );

      localStorage.setItem("selectedPlan", this.selected_plan);
      localStorage.setItem("gB", this.data);
      localStorage.setItem("sms", this.sms);
      localStorage.setItem("minutes", this.minutes);
      localStorage.setItem("amount", this.amount);
      localStorage.setItem("selectedtype", this.selected_type);
      localStorage.setItem("months", this.months);
      localStorage.setItem("sim_name", this.sim_name);
      localStorage.setItem("planname", this.planname);
      localStorage.setItem("datatext", this.datatext);
      localStorage.setItem("normalprice", this.normalprice);
      localStorage.setItem("offersubscription", this.offersubscription);
      localStorage.setItem("offerstatus", this.offerstatus);
      localStorage.setItem("originalamount", this.originalamount);

      window.location.href = process.env.VUE_APP_PORTAL_LINK + "order-plan/create-account?plan_id=" + this.plan.id;
    },
  },
};
</script>

<template>
  <div class="plan-section pt-0 text-center">
    <div class="row plans-container">
      <div
        @click="returnIndex"
        class="plan-box"
        :class="{ dataUnlimited: plan.data === 'unlimited', data5: plan.data === '5', data25: plan.data === '25' }"
      >
        <div class="plan">
          <div class="plan__top plan--padding py-2">
            <p class="plan__unlimited" v-if="plan.data === 'unlimited'">
              <span class="plan__unlimited-best">Best</span> value & most popular
            </p>
          </div>
          <div class="plan__guarantee-container">
            <div class="plan__guarantee-inner">
              <p class="plan__guaranteed p-0 m-0">Guaranteed Acceptance</p>
            </div>
          </div>
          <div class="plan__bottom">
            <div class="plan__costs plan--padding pt-4 pb-2">
              <div v-if="plan.offer_status" class="plan__cost-center">
                <p class="wasPrice m-0 p-0 pe-3">£{{ parseInt(plan.amount) }}</p>
                <h4 class="price">£{{ parseFloat(plan.amount_offer).toFixed(2) }}</h4>
              </div>
              <div v-else class="plan__cost-center">
                <h4 class="price">£{{ parseFloat(plan.amount).toFixed(2) }}</h4>
              </div>
            </div>
            <div class="plan__hr plan--padding">
              <hr class="m-0" />
            </div>
            <div class="plan__name plan--padding">
              <div class="plan__name pb-4">{{ plan.name }}</div>
              <div class="plan__details pb-2">
                <div>{{ plan.data }}{{ plan.data === 'unlimited' ? '' : 'GB' }} Data</div>
                <div>{{ plan.minute }}{{ plan.minute === 'unlimited' ? '' : '' }} Minutes</div>
                <div>{{ plan.sms }}{{ plan.sms === 'unlimited' ? '' : '' }} SMS</div>
              </div>
            </div>
            <div role="button" class="plan__btn">
              <div class="slider-button" @click="passMoreInfo">
                <div class="order-button"><h5 class="order-button__text">Select this plan +</h5></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.plans-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 0 0 1em;
  @media only screen and (min-width: 400px) {
    padding: 0 4em;
  }
  @media only screen and (min-width: 550px) {
    padding: 0 8em;
  }
  @media only screen and (min-width: 576px) {
    padding: 0 1em;
  }

  @media only screen and (min-width: 800px) {
    padding: 0 3em;
  }

  @media only screen and (min-width: 992px) {
    padding: 0 0.5em;
  }

  .plan-box {
    display: flex;
    flex-direction: column;
    border: 1px solid;
    border-radius: 20px;
    overflow: hidden;
    padding: 0;
  }
}

.plan {
  background: var(--light);
  &__top {
    background: var(--black);
    color: var(--primary);
    min-height: 30px;
    font-weight: bold;
  }
  &__unlimited {
    font-size: 0.9em;
    margin-bottom: 15px;
  }
  &__unlimited-best {
    color: var(--banana);
  }
  &__guarantee-container {
    position: relative;
  }
  &__guarantee-inner {
    background: var(--primary);
    position: absolute;
    width: 80%;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    border: solid 1px grey;
    border-radius: 50px;
    padding: 0.25em 0;
  }
  &__guaranteed {
    font-size: 0.8em;
  }
  &__costs {
    display: flex;
    align-items: center;
    margin-top: 15px;
  }
  &__cost-center {
    width: 100%;
    justify-content: center;
    display: flex;
    align-items: start;
  }
  &--padding {
    padding: 0 2em;
  }
  &__name {
    font-size: 1.1em;
    font-weight: bold;
    padding: 0.5em 0;
    @media only screen and (min-width: 800px) {
      font-size: 1.2em;
    }
  }
  &__details {
    font-size: 0.9em;
    font-weight: normal;
    div {
      margin-bottom: 0.2em;
    }
  }
  &__cost-free {
    text-align: left;
    font-size: 0.9em;
    @media only screen and (min-width: 430px) {
      font-size: 1em;
    }
  }
}

.dataUnlimited {
  & > .plan > .plan__top {
    background: var(--gradiant2b);
  }
}

.wasPrice {
  text-decoration: line-through;
}

.price {
  color: var(--lime);
  font-size: 1.9em;
  @media only screen and (min-width: 440px) {
    font-size: 2.1em;
  }
  @media only screen and (min-width: 700px) {
    font-size: 2.3em;
  }
  @media only screen and (min-width: 750px) {
    font-size: 2.5em;
  }
  @media only screen and (min-width: 800px) {
    font-size: 2.7em;
  }
  @media only screen and (min-width: 880px) {
    font-size: 1.8em;
  }
  @media only screen and (min-width: 950px) {
    font-size: 2.2em;
  }
  @media only screen and (min-width: 1000px) {
    font-size: 2.5em;
  }
}

.order-button {
  padding: 1em;
  background: var(--lime);
  cursor: pointer;
  &__text {
    font-size: 1.2em;
  }
}

.plan-section {
  @media only screen and (min-width: 880px) {
    display: flex;
    justify-content: center;
  }
}
</style>
